module.exports = __webpack_public_path__ + "static/media/academy_info_icon.248bc657.svg";